import React from 'react';
import { FaShoppingBag, FaTimesCircle, FaHeart } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

interface UserOrdersEmptyStateProps {
  type: 'error' | 'no-orders' | 'no-filtered-results' | 'no-favorites';
  error?: string | null;
  onRetry?: () => void;
  hasFilters?: boolean;
}

const UserOrdersEmptyState: React.FC<UserOrdersEmptyStateProps> = ({
  type,
  error,
  onRetry,
  hasFilters = false,
}) => {
  const navigate = useNavigate();

  if (type === 'error') {
    return (
      <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg p-12 border border-white/50 text-center">
        <FaTimesCircle className="mx-auto text-6xl text-red-500 mb-6" />
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Bir Hata Oluştu</h3>
        <p className="text-gray-600 mb-6">{error}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="px-8 py-3 bg-gradient-to-r from-green-500 to-green-400 text-white rounded-xl font-medium shadow-lg hover:from-green-600 hover:to-green-500 transition-all transform hover:scale-105"
          >
            Tekrar Dene
          </button>
        )}
      </div>
    );
  }

  if (type === 'no-filtered-results') {
    return (
      <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg p-12 border border-white/50 text-center">
        <FaShoppingBag className="mx-auto text-8xl text-gray-300 mb-6" />
        <h3 className="text-2xl font-bold text-gray-700 mb-3">Sipariş Bulunamadı</h3>
        <p className="text-gray-500 mb-8 max-w-md mx-auto">
          Arama kriterlerinize uygun sipariş bulunamadı. Farklı filtreler deneyebilirsiniz.
        </p>
      </div>
    );
  }

  if (type === 'no-favorites') {
    return (
      <div className="bg-gradient-to-r from-pink-50 to-rose-50 backdrop-blur-sm rounded-xl shadow-lg p-12 border border-pink-100 text-center">
        <FaHeart className="mx-auto text-8xl text-pink-300 mb-6" />
        <h3 className="text-2xl font-bold text-gray-700 mb-3">Henüz Favori Sipariş Yok</h3>
        <p className="text-gray-500 mb-8 max-w-md mx-auto">
          Beğendiğiniz siparişleri favorilerinize ekleyerek daha sonra kolayca tekrar sipariş
          verebilirsiniz. Sipariş kartlarındaki kalp simgesine tıklayarak favorilerinize
          ekleyebilirsiniz.
        </p>
        <button
          onClick={() => navigate('/')}
          className="px-8 py-3 bg-gradient-to-r from-pink-500 to-rose-400 text-white rounded-xl font-medium shadow-lg hover:from-pink-600 hover:to-rose-500 transition-all transform hover:scale-105"
        >
          Sipariş Ver
        </button>
      </div>
    );
  }

  // type === 'no-orders'
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg p-12 border border-white/50 text-center">
      <FaShoppingBag className="mx-auto text-8xl text-gray-300 mb-6" />
      <h3 className="text-2xl font-bold text-gray-700 mb-3">Henüz Sipariş Yok</h3>
      <p className="text-gray-500 mb-8 max-w-md mx-auto">
        İlk siparişinizi vermek için ana sayfayı ziyaret edip lezzetli ürünlerimizi keşfedin.
      </p>
      <button
        onClick={() => navigate('/')}
        className="px-8 py-3 bg-gradient-to-r from-green-500 to-green-400 text-white rounded-xl font-medium shadow-lg hover:from-green-600 hover:to-green-500 transition-all transform hover:scale-105"
      >
        Sipariş Ver
      </button>
    </div>
  );
};

export default UserOrdersEmptyState;
